export const routes = [
    {
        name: `log-in`,
        path: `/login`,
        component: () => import('./LogIn.vue'),
    },
    {
        name: `access-denied`,
        path: `/access-denied`,
        component: () => import('./403.vue'),
    },
];